import { Caption } from "./cms-data";

export class Utils {
  static timecodeToSeconds(input: string): number {
    let value: number = 0;
    const temp: string[] = input.split(":").reverse();
    for (let i = temp.length - 1; i >= 0; i--) {
      value += Number(+temp[i] * Math.pow(60, i));
    }
    return value;
  }

  static splitStringForDoubleCurlies(str: string): string[] {
    const strArray: string[] = [];
    const pattern = /\{{(.*?)\}}/g;
    let match: any = pattern.exec(str);
    while (match != null) {
      strArray.push(match[1]);
      match = pattern.exec(str);
    }
    return strArray;
  }
  static secondsToTimecode(input: number): string {
    if (input) {
      const hours: number = Math.floor(input / 3600);
      const minutes: number = Math.floor((input - hours * 3600) / 60);
      const seconds: number = Math.floor(input - hours * 3600 - minutes * 60);
      const hoursStr: string = hours < 10 ? "0" + hours : hours.toString();
      const minutesStr: string =
        minutes < 10 ? "0" + minutes : minutes.toString();
      const secondsStr: string =
        seconds < 10 ? "0" + seconds : seconds.toString();
      return hoursStr + ":" + minutesStr + ":" + secondsStr;
    } else {
      return "00:00:00";
    }
  }
  static prependProtocol(input: any) {
    const protocol =
      window.location.protocol === "file:"
        ? "https:"
        : window.location.protocol;
    return protocol + input.replace(/^https?:/i, "");
  }

  static getStreamingSource(source: any, extension?: string): any {
    extension = extension ? "." + extension.toLowerCase() : "";
    if (source && source.endsWith("_480")) {
      source = source.substring(0, source.length - 4);
    }
    return source + extension;
  }

  static groupCaptions(captions: Caption[]) {
    const result: Caption[] = [];
    const captionsLength: number = captions.length;
    let fragment: Caption = {
      begin: 0,
      end: 0,
      text: "",
    };
    for (let i: number = 0; i < captionsLength; i++) {
      const caption = captions[i];
      if (caption.text.charAt(0) === caption.text.charAt(0).toUpperCase()) {
        if (fragment.text.length) {
          result.push(fragment);
        }
        fragment = {
          begin: caption.begin,
          end: 0,
          text: "",
        };
      }
      if (caption.text.charAt(caption.text.length - 1) !== ".") {
        fragment.text += (fragment.text.length ? " " : "") + caption.text;
        if (fragment.begin === 0) {
          fragment.begin = caption.begin;
        }
        fragment.end = caption.end;
        continue;
      }
      fragment.text += (fragment.text.length ? " " : "") + caption.text;
      fragment.begin = fragment.text.length ? fragment.begin : caption.begin;
      fragment.end = caption.end;
      result.push(fragment);
      fragment = { text: "", begin: caption.begin, end: 0 };
    }
    return result;
  }

  static getBreakPoint() {
    let breakPoint = 1366;
    if (navigator.userAgent !== null && navigator.userAgent !== undefined) {
      if (navigator.userAgent.match(/Tablet|iPad/i)) {
        breakPoint = 1024;
      } else if (
        navigator.userAgent.match(
          /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry/i
        )
      ) {
        breakPoint = 767;
      }
    }
    return breakPoint;
  }
}
